<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    // Removed.by.KWShin.2024.03.08. liquidChartable.js에 이미 선언되어 있음.
    // title: String,
    value: {
      type: Array,
      required: true,
    },
    // Added.by.KWShin.2022.07.08.
    isPcapOs: Boolean,
  },
  computed: {
    // BEGIN::Added.by.KWShin.2024.03.12.
    title() {
      return this.$t('dv.title.cpu');
    },
    // FINISH::Added.by.KWShin.2024.03.12.
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  data() {
    return {
      data: {
        value: '',
        type: 'percent',
      },
    };
  },
  methods: {
    /**
     * Modified.by.KWShin.2024.03.08.
     * OS 화면은 인스턴스가 single select 모드로 되어 있었으나,
     * 전체를 한꺼번에 볼 수 있게끔 정책 변경을 하므로써,
     * 단일 인스턴스 선택 시에는 해당 인스턴스 값,
     * 전체 인스턴스 선택 시에는 평균값을 보여주도록 로직을 수정함.
     *
     * 그리드 쪽에서 데이터를 읽을 때 전체 혹은 단일 인스턴스의 데이터를 알아서 읽어줌.
     */
    /*  
    setData(data) {
      const [result] = data;
      if (result) {
        // BEGIN:Added.by.KWShin.2022.07.08.
        if (this.isPcapOs) {
          this.data.value = Math.round(parseFloat(result.usrTotal) + parseFloat(result.sysTotal));
          // FINISH:Added.by.KWShin.2022.07.08.
        } else {
          this.data.value = parseInt(result.usrTotal) + parseInt(result.sysTotal);
        }
      } else this.data.value = '0';
    },
    */
    setData(dataList) {
      if (dataList.length > 0) {
        let count = 0;
        let sum = 0;
        dataList.forEach(datum => {
          count += 1;
          if (this.isPcapOs) {
            sum += parseFloat(datum.usrTotal) + parseFloat(datum.sysTotal);
          } else {
            sum += parseInt(datum.usrTotal) + parseInt(datum.sysTotal);
          }
        });
        this.data.value = Math.ceil(sum / count);
      } else this.data.value = '0';
    },
  },
};
</script>
